import { NEW_CLIENT_DETAIL, NEW_PROVIDER_DETAIL, NEW_INVOICES_TO_PAY, NEW_PORTAL_INVOICES, NEW_PAYMENT_METHODS, NEW_CLIENT_SETTINGS, CLIENT_TAXES_LIST, SELECT_NOTE_TO_INVOICE, NEW_CONTRACT_KPIS } from '../actions/portalActions';

const initialState = {
  client: {},
  provider: {},
  invoices: [],
  invoicesToPay: [],
  paymentMethods: [],
  settings: {},
  taxesList: [],
  note: null,
  contractKpis: null

} // END initialState

export default function (state = initialState, action) {
  const { type, payload } = action;
  let newState;

  switch (type) {
    case NEW_CLIENT_DETAIL:
      newState = { client: payload };
      return { ...state, ...newState };

    case NEW_PROVIDER_DETAIL:
      newState = { provider: payload };
      return { ...state, ...newState };

    case NEW_INVOICES_TO_PAY:
      newState = { invoicesToPay: payload};
      return { ...state, ...newState};

    case NEW_PORTAL_INVOICES:
      newState = { invoices: payload};
      return { ...state, ...newState};

    case NEW_PAYMENT_METHODS:
      newState = { paymentMethods: payload }
      return { ...state, ...newState};

    case NEW_CLIENT_SETTINGS:
      newState = { settings: payload }
      return { ...state, ...newState};

    case CLIENT_TAXES_LIST:
      newState = { taxesList: payload }
      return { ...state, ...newState};

    case SELECT_NOTE_TO_INVOICE:
      newState = { note: payload }
      return { ...state, ...newState};

    case NEW_CONTRACT_KPIS:
      newState = { contractKpis: payload }
      return { ...state, ...newState };

    default:
      return state;

  } // END switch;

} // END reduce



// WEBPACK FOOTER //
// ./src/redux/reducers/portalReducer.js